import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { TenantSelector } from "./TenantSelector";
import { UserMenu } from "./UserMenu";
import { COLLAPSED_WIDTH } from "./VerticalNavigation";

/**
 * Header - Top navigation bar composition
 *
 */
export const Header: React.FC = () => {
  return (
    <Box
      data-testid="header-container"
      sx={{
        position: "fixed",
        top: 0,
        left: COLLAPSED_WIDTH,
        width: `calc(100% - ${COLLAPSED_WIDTH}px)`,
        height: "var(--app-header-height)",
        boxSizing: "border-box",
        zIndex: 1100,
        background: "#FFF",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 3,
          py: 2.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography
            sx={{
              fontFamily: "EnterpriseSansVF, Arial, sans-serif",
              fontWeight: 700,
              fontSize: "23px",
              color: "#3D3C38",
              whiteSpace: "nowrap",
              borderRight: "1px solid #3D3C38",
              pr: 3,
              mr: 3,
              pt: "4px",
              pb: "4px",
            }}
          >
            Advanced Claim View
          </Typography>
          <TenantSelector />
        </Box>
        <UserMenu />
      </Box>
    </Box>
  );
};
